import request from '@/utils/request'

/**
 * 获取学情分析统计概览
 */
export function getLearningAnalysisSummary() {
    return request({
        url: '/api/admin/learning-analysis/summary',
        method: 'get'
    })
}

/**
 * 获取建议参考学员分页列表
 */
export function getLearningAnalysisRecommendList(params) {
    return request({
        url: '/api/admin/learning-analysis/recommend-list',
        method: 'get',
        params
    })
}